import cn from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { DIGITAL_DELIVERY_ONLY_MESSAGE } from 'constants/siteMessages';
import { UPDATE_ITEM_QUANTITY } from 'constants/checkoutButtons';

import ContentBox from 'components/checkout/caap/ContentBox';
import { toUSD } from 'helpers/NumberFormats';
import css from 'styles/components/checkout/caap/spc/reviewitems/digitalItem.scss';
import {
  productName as cssProductName,
  desktopPriceBox,
  form,
  imgBox,
  itemPrice,
  itemRow,
  last,
  productDetailsBox,
  quantityBox,
  quantityWrapper,
  showOnlySmallScreen
} from 'styles/components/checkout/caap/spc/reviewItems.scss';

const DigitalItem = (params, { testId }) => {
  const {
    deliveryGroup,
    excludeShipOptions,
    groupHeader,
    hasGcQuantityCv,
    isFetchingCheckoutData,
    onChangeQuantity,
    productsByLineItem,
    showTopDivider
  } = params;
  const { lineItemIds } = deliveryGroup;

  return (
    <>
      {
        renderHeading({ excludeShipOptions, testId, groupHeader })
      }
      {
        lineItemIds.slice().map((unmappedLineItemId, index) => {
          const mappedItem = productsByLineItem[unmappedLineItemId];
          const { asin, productName, color, gcCustomization: { recipientEmail, message, senderName }, image: { url: imageUrl, alt: imageAlt }, lineItemId, price } = mappedItem;
          const isLast = index === lineItemIds.length - 1;
          const updateQuantityButtonId = `${UPDATE_ITEM_QUANTITY}-${lineItemId}`;
          const rowStyles = cn(itemRow, { [last]: isLast });

          return (
            <div className={rowStyles} key={`${lineItemId}-${index}`}>
              { excludeShipOptions && showTopDivider && <hr className={css.divider} /> }
              { excludeShipOptions && <div className={css.title}>Digital Delivery</div> }
              <div className={imgBox}>
                <Link
                  to={`/p/asin/${asin}`}
                  data-te="TE_CHECKOUT_REV_GO_TO_PDP"
                  data-ted={asin}
                  data-test-id={testId('productImage')}>
                  <img width="80" src={imageUrl} alt={imageAlt} />
                </Link>
              </div>

              <div className={productDetailsBox}>
                <div className={cssProductName}>
                  <Link
                    to={`/p/asin/${asin}`}
                    data-te="TE_CHECKOUT_REV_GO_TO_PDP"
                    data-ted={asin}
                    data-test-id={testId('productName')}>
                    {productName}
                  </Link>
                  <div>Color: {color}</div>
                  <div className={`${itemPrice} ${showOnlySmallScreen}`}>{toUSD(price)}</div>
                  <div>Send To: {recipientEmail}</div>
                  <div>From: {senderName}</div>
                  {
                    message
                      ? <>
                        <div><strong>Message:</strong></div>
                        <div className={css.egcMessage}>{message}</div>
                      </>
                      : null
                  }
                </div>
              </div>

              <div className={desktopPriceBox}>
                <div className={itemPrice} data-test-id={testId('itemPrice')}>{toUSD(price)}</div>
              </div>

              <div className={`${quantityBox} ${quantityWrapper} ${form}`}>
                <button
                  className={css.checkoutSecondaryButton}
                  disabled={isFetchingCheckoutData}
                  id={updateQuantityButtonId}
                  onClick={e => onChangeQuantity(e, lineItemId)}
                  type="button"
                  value="0">
                  remove
                </button>
              </div>

              {
                hasGcQuantityCv && <div className={css.errorBox}>
                  <div className={css.errorContainer}>
                    <p>You may only have 1 E-Gift Card per purchase.</p>
                  </div>
                </div>
              }
            </div>
          );
        })
      }
    </>
  );
};

const renderHeading = ({ excludeShipOptions, testId, groupHeader }) => (
    <>
      <div className={showOnlySmallScreen}>
        <h2 data-test-id={testId('digitalShipmentDetails')}>
          { groupHeader }
        </h2>
      </div>
      {
        !excludeShipOptions && <ContentBox isFirst={true} isNonRadio={true}>
          <div className={css.ddMessage}>
            <strong>Digital delivery: </strong>
            { DIGITAL_DELIVERY_ONLY_MESSAGE }
          </div>
        </ContentBox>
      }
    </>
);

DigitalItem.contextTypes = {
  testId: PropTypes.func
};

export default DigitalItem;
